import { shallowEqual, useSelector } from 'react-redux';
import { Store } from 'types/Store';

/**
 * The signed-in user's permission keys, re-rendering when the list changes.
 *
 * The list is re-read after a billing change (e.g. the Analytics module is
 * activated), so consumers must not freeze the first value they read — an
 * always-true equality fn did exactly that, and the route guard, the menu and
 * the command palette kept hiding Analytics until a page reload.
 */
const usePermissionsKeys = (): string[] =>
  useSelector<Store, string[]>(
    (state) => state?.user?.permissionsKeys || [],
    shallowEqual,
  );

export default usePermissionsKeys;
